var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.menu_),function(x,idx){return _c('div',{key:idx,staticClass:"pb-1"},[_c('router-link',{attrs:{"to":x.link,"title":x.title}},[_c('span',[_c('icon',{attrs:{"name":x.ico}}),_vm._v("\n          "+_vm._s(_vm.$t(x.title))+"\n          ")],1)])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e0e2292","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cQuickLinks.vue
// module id = null
// module chunks = 